import { createRoot } from "react-dom/client";
import * as kiwiSdk from "@huyafed/huya-kiwi";
import { tafFetch } from "@/api/_tafFetch";
import { GAME_ID, TOOL_ID } from "@/config/env";
import Constants from "@/constants";
import logger from "@/utils/logger";
import App from "./App";

const logRuntimeInitializationError = (error: unknown) => {
  const message = "[GameToolRuntime] initialization failed";
  try {
    logger.error(message, { error });
  } catch (loggerError) {
    console.warn("[GameToolRuntime] SDK logger failed:", loggerError);
  }
  console.warn(`${message}:`, error);
};

try {
  void window.GameToolRuntime
    ?.init({
      gameId: GAME_ID,
      toolId: TOOL_ID,
      env: Constants.IS_DEBUG ? "test" : "prod",
      tafFetch,
      sdk: kiwiSdk,
    })
    .catch(logRuntimeInitializationError);
} catch (error) {
  logRuntimeInitializationError(error);
}

createRoot(document.getElementById("root")!).render(<App />);
